/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ComplianceFormAdditionalFileIEnumerableResponse } from '../models';
import { ComplianceFormFileResponse } from '../models';
import { ComplianceFormIEnumerableResponse } from '../models';
import { ComplianceFormRequest } from '../models';
import { FileResponse } from '../models';
import { FileStreamResultResponse } from '../models';
import { RegeneratedFileLogIEnumerableResponse } from '../models';
/**
 * ComplianceFormApi - axios parameter creator
 * @export
 */
export const ComplianceFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile as a stream
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadAdditionalFile-stream/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadComplianceFormAdditionalFile/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadEeReportEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2ComplianceFormDownloadEeReportEeReportIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadEeReport/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet: async (eeReportId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadEeReport/{eeReportId}/{regeneratedFileLogId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ComplianceForm File
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet: async (fileId: number, complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet.');
            }
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadFile/{fileId}/{complianceFormId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartAPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2ComplianceFormDownloadPartAPartAIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadPartA/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet: async (partAId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadPartA/{partAId}/{regeneratedFileLogId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartBPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2ComplianceFormDownloadPartBPartBIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadPartB/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet: async (partBId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/DownloadPartB/{partBId}/{regeneratedFileLogId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/GetComplianceFormAdditionalFile/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ComplianceForms
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormsPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/GetComplianceForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns EeReportLogs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/GetEeReportFileLogs/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/GetFileAttachments/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartALogs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetPartAFileLogsPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2ComplianceFormGetPartAFileLogsPartAIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/GetPartAFileLogs/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PartBLogs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetPartBFileLogsPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2ComplianceFormGetPartBFileLogsPartBIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/GetPartBFileLogs/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceFormApi - functional programming interface
 * @export
 */
export const ComplianceFormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile as a stream
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ComplianceForm File
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadPartAPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadPartBPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormAdditionalFileIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ComplianceForms
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetComplianceFormsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns EeReportLogs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns ComplianceFormFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormFileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartALogs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PartBLogs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComplianceFormApi - factory interface
 * @export
 */
export const ComplianceFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile as a stream
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): AxiosPromise<FileStreamResultResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns EeReport File
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ComplianceForm File
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadPartAPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartA File
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadPartBPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartB File
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ComplianceFormAdditionalFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormAdditionalFileIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ComplianceForms
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<ComplianceFormIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetComplianceFormsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns EeReportLogs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns ComplianceFormFile
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormFileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartALogs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PartBLogs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComplianceFormApi - object-oriented interface
 * @export
 * @class ComplianceFormApi
 * @extends {BaseAPI}
 */
export class ComplianceFormApi extends BaseAPI {
    /**
     * 
     * @summary Returns ComplianceFormAdditionalFile as a stream
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ComplianceFormAdditionalFile
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns EeReport File
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns EeReport File
     * @param {number} eeReportId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ComplianceForm File
     * @param {number} fileId 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartA File
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadPartAPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartA File
     * @param {number} partAId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartB File
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadPartBPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartB File
     * @param {number} partBId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ComplianceFormAdditionalFile
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ComplianceForms
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetComplianceFormsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns EeReportLogs
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns ComplianceFormFile
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartALogs
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PartBLogs
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
}
